import React from "react";

const PrimaryText = ({style, ...otherProps}) => (
    <p style={Object.assign({color: "var(--primary)", margin: "1em auto"}, style)}
       {...otherProps}
    />
)

export default PrimaryText;